import { API as MockAPI } from './mockApi';
import { RealAPI } from './realApi';

const useMock = process.env.REACT_APP_USE_MOCK === 'true' || process.env.NODE_ENV === 'test';

console.log('API Mode:', useMock ? 'MOCK' : 'REAL');

export const API = useMock ? MockAPI : RealAPI;
export default API;
